import {match} from 'ts-pattern';

import {isEmpty, last} from 'ramda';

import {Nullish} from 'shared/web';

import {ALL_BANK_ACCOUNT_DOMAINS} from '../constants/ALL_BANK_ACCOUNT_DOMAINS';
import type {BankAccountDomainSelectValue} from '../types/BankAccountDomainSelectValue';

/**
 * Keeps the "All" option mutually exclusive with the real domains.
 * react-select appends the newest pick last, so the last element reveals the
 * user's latest intent:
 * - empty selection -> fall back to "All" (an account always has a domain scope)
 * - "All" just picked -> collapse to "All" only
 * - a real domain present -> drop "All"
 */
export function normalizeBankAccountDomainSelection(
  selection: BankAccountDomainSelectValue[] | Nullish
): BankAccountDomainSelectValue[] {
  const currentSelection = selection ?? [];
  const allDomainsSelection: BankAccountDomainSelectValue[] = [ALL_BANK_ACCOUNT_DOMAINS];

  return match(currentSelection)
    .when(isEmpty, () => allDomainsSelection)
    .when(
      (domains) => last(domains) === ALL_BANK_ACCOUNT_DOMAINS,
      () => allDomainsSelection
    )
    .otherwise((domains) => domains.filter((domain) => domain !== ALL_BANK_ACCOUNT_DOMAINS));
}
